import { Trophy } from "lucide-react";

/**
 * RecentWinCard — celebrates the most recently defeated bill. Consumes the
 * same `subs` list the dashboard already has; picks the newest defeated one.
 */
export default function RecentWinCard({ subs = [] }) {
  const defeated = subs.filter((s) => s.defeated);
  if (defeated.length === 0) {
    return (
      <div
        className="rounded-2xl bg-[#0B221D] border border-dashed border-[#1B4238] p-4 flex items-center gap-3 min-h-[112px]"
        data-testid="recent-win-empty"
      >
        <div className="w-11 h-11 rounded-2xl bg-[#0F2E27] flex items-center justify-center flex-shrink-0">
          <Trophy className="w-5 h-5 text-[#5F7E76]" strokeWidth={2.4} />
        </div>
        <div className="flex-1 min-w-0">
          <p
            className="text-[10px] font-black uppercase tracking-[0.18em] text-[#F5D849]"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Recent Win
          </p>
          <p className="text-[11px] text-[#93B1A8] mt-1 leading-snug">
            Defeat your first bill to unlock a trophy here.
          </p>
        </div>
      </div>
    );
  }

  const latest = defeated
    .slice()
    .sort((a, b) => {
      const ad = new Date(a.defeated_at || a.updated_at || 0).getTime();
      const bd = new Date(b.defeated_at || b.updated_at || 0).getTime();
      return bd - ad;
    })[0];
  const saved = Number(latest.monthly_cost || 0);

  return (
    <div
      className="rounded-2xl bg-[#0B221D] border border-[#1B4238] p-4 relative overflow-hidden"
      data-testid="recent-win-card"
    >
      <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full bg-[#F5D849]/10 blur-2xl" aria-hidden />
      <div className="relative flex items-start gap-3">
        <div className="w-12 h-12 rounded-2xl bg-[#0F2E27] border border-[#F5D849]/40 flex items-center justify-center flex-shrink-0">
          <Trophy className="w-6 h-6 text-[#F5D849]" strokeWidth={2.6} />
        </div>
        <div className="flex-1 min-w-0">
          <p
            className="text-[10px] font-black uppercase tracking-[0.18em] text-[#F5D849]"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Recent Win
          </p>
          <p
            className="text-sm font-extrabold text-white leading-tight mt-0.5 truncate"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="recent-win-name"
          >
            You defeated <span className="text-[#F5D849]">{latest.name}</span>
          </p>
          <p className="text-[11px] font-bold text-[#22E07A] mt-0.5">
            +${saved.toFixed(2)} saved{saved > 0 ? "/mo" : ""}
          </p>
        </div>
      </div>
    </div>
  );
}
